export default {
    API_BASE: 'https://d3qod0vpxxf6jc.cloudfront.net/api/'
}